import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BACKEND_URL } from "../Config/Config";

/**
 * Generation timing for a single endpoint: every recorded run with its start/end time,
 * duration and test-case count.
 */
const fetchEndpointGenerationMetrics = async ({ queryKey }) => {
  const [, endpointId] = queryKey;
  const response = await axios.get(
    `${API_BACKEND_URL}/testcase/generation-metrics?endpointId=${endpointId}`,
  );
  return response.data;
};

export const useGenerationMetrics = (endpointId, options = {}) => {
  return useQuery({
    queryKey: ["generationMetrics", endpointId],
    queryFn: fetchEndpointGenerationMetrics,
    enabled: Boolean(endpointId),
    ...options,
  });
};

const fetchCollectionGenerationMetrics = async ({ queryKey }) => {
  const [, collectionId] = queryKey;
  const response = await axios.get(
    `${API_BACKEND_URL}/testcase/generation-metrics/collection?collectionId=${collectionId}`,
  );
  return response.data;
};

export const useCollectionGenerationMetrics = (collectionId, options = {}) => {
  return useQuery({
    queryKey: ["generationMetricsCollection", collectionId],
    queryFn: fetchCollectionGenerationMetrics,
    enabled: Boolean(collectionId),
    ...options,
  });
};
